import { Button, Dialog } from "@mui/material";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { compressImageWithFallback } from "../../services/ImageCompressionService";
import { Loading } from "../Loading";

type Props = {
  label: string;
  onLoad: (image: string) => void;
};

export const ButtonUploadImage: React.FC<Props> = ({ label, onLoad }) => {
  const { t } = useTranslation();
  const [loading, setLoading] = React.useState<boolean>(false);

  return (
    <>
      <Button size="small" variant="contained" component="label">
        {label}
        <input
          type="file"
          hidden
          accept="image/*"
          onChange={async (evt) => {
            setLoading(true);
            const file = evt.target.files[0];
            if (file) {
              try {
                const compressedDataUri = await compressImageWithFallback(file);
                setLoading(false);
                onLoad(compressedDataUri);
              } catch (error) {
                console.error("Image compression failed:", error);
                setLoading(false);
              }
            }
          }}
        />
        <Dialog open={loading} onClose={() => setLoading(false)} fullScreen>
          <Loading message={t('widgets.buttonUploadImage.compressingMessage')} />
        </Dialog>
      </Button>
    </>
  );
};
